import { PaymentFormData } from '../billing-forms/types';
import { CreateCustomer } from '../core/types';

/**
 * Gets the create custome payload.
 * @param {PaymentFormData} paymentFormData
 * @returns {CreateCustomer}
 */
export function getCreateCustomerPayload({
  vat,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  state
}: PaymentFormData): CreateCustomer {
  return {
    vat_number: vat,
    billing_address: {
      city,
      country,
      line1: addressLine1,
      line2: addressLine2,
      zip: postalCode,
      state: state?.label,
      state_code: state?.value as string | undefined
    }
  };
}
